export const RECORDING_OVERLAY_MESSAGE_TYPES = {
  SUCCESS: 'SUCCESS',
  FAIL: 'FAIL',
  PAUSED: 'PAUSED'
};

export const RECORDING_OVERLAY_MESSAGE_DURATION = 1000;
export const SIDEBAR_VISIBILITY_PERIOD = 90 * 24 * 60 * 60 * 1000;

export const RS_SYSTEM_REQUIREMENTS_CHECKS = [
  'system_cores',
  'system_storage',
  'system_network',
  'system_os',
  'system_browser'
];
